const smallWords = ['AND', 'OF'];
const alwaysCapitalize = ['SAE', 'DOT', 'SAF'];
const vowels = ['a', 'e', 'i', 'o', 'u'];

/**
 * Capitalize Brand Names. In general, this capitalizes the first letter of each word, and lowercases the rest.
 * Also includes logic for special cases:
 * Words with 2 characters or fewer use all capitals,
 * words from the "smallWords" list are not capitalized at all,
 * words from the "alwaysCapitalize" list are always capitalized,
 * the first alphabetic character after a non-alphabetic character is capitalized,
 * strings with 3 or fewer letters are capitalized, unless a vowel is in the middle,
 * words containing a digit are always capitalized,
 * hyphenated words have each piece processed separately, and the result is joined with hyphens
 *
 * @param {string} brandName The brand name string. No particular case is assumed.
 * @returns {string} The sentence-case capitalized brand name.
 */
function capitalizeBrand(brandName) {
  const words = brandName.split(' ');
  if (words.length === 1 && words[0].length < 4) {
    const hasMiddleVowel =
      brandName.length === 3 && isVowel(brandName.charAt(1));
    if (!hasMiddleVowel || alwaysCapitalize.includes(brandName.toUpperCase())) {
      return brandName.toUpperCase();
    }
  }

  let result = '';
  let first = true;
  for (let word of words) {
    if (first) {
      first = false;
    } else {
      result += ' ';
    }

    let modWord = word
      .split('-')
      .map(word => processWord(word))
      .join('-');

    result += modWord;
  }
  return result;
}

function processWord(word) {
  let modWord = '';

  if (smallWords.includes(word)) {
    modWord += word.toLowerCase();
  } else if (alwaysCapitalize.includes(word.toUpperCase())) {
    modWord += word.toUpperCase();
  } else if (word.length < 3) {
    modWord = word.toUpperCase();
  } else if (/\d/.test(word)) {
    modWord = word.toUpperCase();
  } else {
    let capNext = true;
    for (let char of word) {
      if (!isAlphaChar(char)) {
        modWord += char;
        capNext = true;
        continue;
      }

      if (capNext) {
        modWord += char.toUpperCase();
        capNext = false;
      } else {
        modWord += char.toLowerCase();
      }
    }
  }
  return modWord;
}

function isAlphaChar(ch) {
  return ch >= 'A' && ch <= 'z';
}

function isVowel(ch) {
  return vowels.includes(ch.toLowerCase());
}

export { capitalizeBrand };
